module.exports = __webpack_public_path__ + "static-m/img/head_bg.9140dfac.jpg";